module.exports = __webpack_public_path__ + "img/logo-warner-new.05393429.png";